const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
        title: 'Withdrawal Amount',
        dataIndex: 'amount',
        sorter: (a, b) => a?.amount - b?.amount,
    },
    {
        title: 'Transaction Type',
        dataIndex: 'transactionType',
        sorter: (a, b) => a?.transactionType?.localeCompare(b?.transactionType),
    },
    {
        title: 'Transaction Date',
        dataIndex: 'transactionDate',
        sorter: (a, b) => a?.transactionDate?.localeCompare(b?.transactionDate),
    },
    {
        title: 'Status',
        dataIndex: 'status',
    },
];

export default columns;